import ReactDOM from 'react-dom';
import { createElement } from 'react';
import '@jupiter-app/runtime';
import axios from 'axios';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

// 多种渲染方式
var RENDER_LEVEL;

(function (RENDER_LEVEL) {
  RENDER_LEVEL[RENDER_LEVEL["CLIENT_RENDER"] = 0] = "CLIENT_RENDER";
  RENDER_LEVEL[RENDER_LEVEL["SERVER_PREFETCH"] = 1] = "SERVER_PREFETCH";
  RENDER_LEVEL[RENDER_LEVEL["SERVER_RENDER"] = 2] = "SERVER_RENDER";
})(RENDER_LEVEL || (RENDER_LEVEL = {}));

// polyfill
if (!String.prototype.trim) {
  // eslint-disable-next-line no-extend-native
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
}

function parseLocationSearch() {
  return window.location.search.substr(1).split('&').reduce(function (query, pair) {
    var _pair$split = pair.split('='),
        _pair$split2 = _slicedToArray(_pair$split, 2),
        key = _pair$split2[0],
        value = _pair$split2[1];

    query[key] = value;
    return query;
  }, {});
}

function parseCookieStr() {
  var cookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return cookie.split(';').map(function (c) {
    return c.trim().split('=').map(decodeURIComponent);
  }).reduce(function (a, b) {
    try {
      a[b[0]] = JSON.parse(b[1]);
    } catch (e) {
      a[b[0]] = b[1];
    }

    return a;
  }, {});
} // props._context.source.rawRequest.headers.host,
// props._context.source.rawRequest.url,
// smoothing 【browser、server】 context differences


function consistContext(_context) {
  // node
  {
    var _context2 = _context;
    _context2.isBrowser = true; // browser

    var _window = window,
        navigator = _window.navigator,
        document = _window.document,
        location = _window.location;
    _context2.request || (_context2.request = {});
    Object.assign(_context2.request, {
      userAgent: navigator.userAgent || '',
      language: window._SSR_DATA && window._SSR_DATA.data && window._SSR_DATA.data.i18nData && window._SSR_DATA.data.i18nData.lng || navigator.language || '',
      referer: document.referrer || '',
      cookie: document.cookie || '',
      cookieMap: parseCookieStr(document.cookie),
      url: location.href || '',
      host: location.host || '',
      pathname: _context2.request.pathname || location.pathname,
      query: _context2.request.query || parseLocationSearch()
    });
  }
} // wrap init


function wrapperAppInit(AppWrapper) {
  // original App.init
  var _init = AppWrapper.init;

  AppWrapper.init = function (context) {
    try {
      var _temp2 = function _temp2(_init2) {
        _init2;
      };

      consistContext(context); // node

      if (!true) {
        // enable styled-components by default
        context.enableStyledComponent = true; // ssr server 先执行 prefetch，再输出 html
        // config.enableHelmet && ((context as ServerContext).awaitPrefetch = true);
      }

      return Promise.resolve(_init ? Promise.resolve(_init(context)).then(_temp2) : _temp2(_init));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var asyncSSRDataFetch = (function (hash, requestUrl) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2000;
  var reset = arguments.length > 3 ? arguments[3] : undefined;
  var downgrade = arguments.length > 4 ? arguments[4] : undefined;

  try {
    var _temp2 = _catch(function () {
      return Promise.resolve(axios.get("".concat(requestUrl, "?uuid=").concat(hash), {
        timeout: timeout
      })).then(function (res) {
        var data = res.data;

        if (!data) {
          downgrade();
        } else {
          reset(data);
        }
      });
    }, function () {
      downgrade();
    });

    return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
  } catch (e) {
    return Promise.reject(e);
  }
});

function runtimeSSR() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var customPrefetch = config.customPrefetch,
      enableProductWarning = config.enableProductWarning;

  var _windowLoadersPromiseMapData;

  var renderLevel = RENDER_LEVEL.CLIENT_RENDER;
  var clientContext = null;
  var _ssrData = null;
  var resetSSRData;
  var downgradeRenderLevel; // browser, ssr data

  {
    _ssrData = window._SSR_DATA || (window._SSR_DATA = {});
    _ssrData.data || (_ssrData.data = {});
    _windowLoadersPromiseMapData = _ssrData.data.loadersData || (_ssrData.data.loadersData = {});
    renderLevel = _ssrData.renderLevel || (_ssrData.renderLevel = RENDER_LEVEL.CLIENT_RENDER);
    clientContext = _ssrData.context || (_ssrData.context = {});

    resetSSRData = function resetSSRData(data) {
      _ssrData.data = data || {};
      _windowLoadersPromiseMapData = _ssrData.data.loadersData || (_ssrData.data.loadersData = {});
    };

    downgradeRenderLevel = function downgradeRenderLevel() {
      renderLevel = RENDER_LEVEL.CLIENT_RENDER;
    };
  }

  var specialHook = {
    onBootStrap: function onBootStrap(AppComponment, rootElement) {
      try {
        var _temp10 = function _temp10() {
          var _exit = false;

          function _temp7(_result4) {
            if (_exit) return _result4;

            var _temp5 = _catch(function () {
              function _temp4() {
                if (renderLevel > RENDER_LEVEL.SERVER_PREFETCH) {
                  // lite ssr: 需传递 _ssrData 给根组件
                  var serverHTML = rootElement.innerHTML;
                  ReactDOM.hydrate(createElement(AppComponment, {
                    _ssrData: _ssrData
                  }), rootElement);
                  var hydrateHTML = rootElement.innerHTML;

                  if (serverHTML !== hydrateHTML && enableProductWarning) {
                    console.error('Error: onBootStrap: csr is different with ssr, please check in the development environment for more information');
                  }
                } else {
                  ReactDOM.render(createElement(AppComponment, {
                    _ssrData: _ssrData
                  }), rootElement);
                }
              }

              var asyncHash = clientContext && clientContext.async;

              var _temp3 = function () {
                if (asyncHash) {
                  var asyncUrl = config.asyncSSRDataUrl || '';
                  var timeout = config.asyncDataTimeout;
                  return Promise.resolve(asyncSSRDataFetch(asyncHash, asyncUrl, timeout, resetSSRData, downgradeRenderLevel)).then(function () {});
                }
              }();

              return _temp3 && _temp3.then ? _temp3.then(_temp4) : _temp4(_temp3);
            }, function (error) {
              console.error('Error: onBootStrap: ', error);
            });

            return _temp5 && _temp5.then ? _temp5.then(function () {
              return AppComponment;
            }) : AppComponment;
          }

          // dev 环境下校验错误，如果存在 Server render error，则打印到浏览器控制台
          if (process.env.NODE_ENV === 'development') {
            var hasErr = renderLevel < RENDER_LEVEL.SERVER_RENDER;

            if (renderLevel === RENDER_LEVEL.SERVER_RENDER) {
              var _ssrData$data;

              var loaderData = (_ssrData$data = _ssrData.data) === null || _ssrData$data === void 0 ? void 0 : _ssrData$data.loadersData;

              if (loaderData) {
                hasErr = Object.keys(loaderData).some(function (loaderId) {
                  return loaderData[loaderId]._error;
                });
              }
            }

            if (hasErr) {
              console.error('SSR Error: there have been some mistakes, please check the shell');
            }
          }

          var LoadingComponent = window.__CUSTOMPREFETCH_LOADINGCOMPONENT__;
          var ErrorComponent = window.__CUSTOMPREFETCH_ERRORCOMPONENT__;

          var _temp6 = function () {
            if (LoadingComponent) {
              var _temp12 = function () {
                if (renderLevel === RENDER_LEVEL.CLIENT_RENDER) {
                  ReactDOM.render(createElement(LoadingComponent, {
                    _ssrData: _ssrData
                  }), rootElement);

                  var _temp13 = _catch(function () {
                    // eslint-disable-next-line require-atomic-updates
                    return Promise.resolve(AppComponment.prefetch(clientContext)).then(function (_AppComponment$prefet) {
                      _ssrData.data = _AppComponment$prefet;
                    });
                  }, function (e) {
                    if (ErrorComponent) {
                      ReactDOM.render(createElement(ErrorComponent, {
                        error: e
                      }), rootElement);
                    }

                    _exit = true;
                  });

                  if (_temp13 && _temp13.then) return _temp13.then(function () {});
                }
              }();

              if (_temp12 && _temp12.then) return _temp12.then(function () {});
            }
          }();

          return _temp6 && _temp6.then ? _temp6.then(_temp7) : _temp7(_temp6);
        };

        // node
        if (!true) {
          return Promise.resolve(AppComponment);
        }

        var _temp11 = function () {
          if (AppComponment.init) {
            return Promise.resolve(AppComponment.init(clientContext)).then(function () {});
          }
        }();

        return Promise.resolve(_temp11 && _temp11.then ? _temp11.then(_temp10) : _temp10(_temp11));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    onCreateApp: function onCreateApp(AppWrapper) {
      // 对 App.init 包裹
      wrapperAppInit(AppWrapper); // if custom App.prefetch

      if (customPrefetch && customPrefetch.LoadingComponent && AppWrapper.prefetch) {
        {
          // NOTICE: mark is custom prefetch
          window.__CUSTOMPREFETCH_LOADINGCOMPONENT__ = customPrefetch.LoadingComponent;
          window.__CUSTOMPREFETCH_ERRORCOMPONENT__ = customPrefetch.ErrorComponent;
        }

        var _prefetch = AppWrapper.prefetch; // 自定义 prefetch 接口(避免SSR二次渲染), 如果 node-prefetch 调用失败, 则 browser-prefetch 会再调用

        AppWrapper.prefetch = function (context) {
          try {
            var _exit3 = false;

            var _temp16 = function _temp16(_result5) {
              if (_exit3) return _result5;
              ssrData.prefetchData = prefetchData;
              var i18nData = context.__i18nData__;
              i18nData && (ssrData.i18nData = i18nData);
              var garrListResp = context.__GARRLISTRESP__;
              var garrTargetMApp = context.__GARRTARGETMAPP__;
              garrListResp && (ssrData.garrListResp = garrListResp);
              garrTargetMApp && (ssrData.garrTargetMApp = Array.from(garrTargetMApp));
              return ssrData;
            };

            var ssrData = {};
            var prefetchData;

            var _temp17 = _catch(function () {
              return Promise.resolve(_prefetch(context)).then(function (_prefetch2) {
                prefetchData = _prefetch2;
              });
            }, function (e) {
              console.error('Error: App.prefetch catch error', e);
              throw e;
            });

            return Promise.resolve(_temp17 && _temp17.then ? _temp17.then(_temp16) : _temp16(_temp17));
          } catch (e) {
            return Promise.reject(e);
          }
        };

        return AppWrapper;
      } // node

      return AppWrapper;
    }
  }; // browser, used sepcially for [bootstrap] method

  {
    if (!window.__SPECIALHOOK__) {
      window.__SPECIALHOOK__ = {};
    }

    window.__SPECIALHOOK__['@jupiter-app/plugin-ssr'] = specialHook;
  }

  var plugin = function plugin() {
    return {
      name: '@jupiter-app/plugin-ssr',
      onContainerLoader: function onContainerLoader(loader, props, appContext) {
        var extraArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
        // 1. browser, directly from window._SSR_DATA.data
        // 2. node ssr, first render. [appContext._loadersPromiseMap] is loader Prmomise collect object
        // 3. node ssr, second render. [appContext._loadersPromiseMap] is loader Prmomise result object
        var loadersPromiseMap =  _windowLoadersPromiseMapData ; // loader 函数标识 id，后续不会再变化

        var loaderId = loader._id;
        var promiseRt = loadersPromiseMap[loaderId];
        var _ssrData = appContext._ssrData;
        /* start */

        {
          // on browser client, downgrade to re-request
          // no ssr || ssr loader pending || ssr loader fail || mark destory
          if (!promiseRt || promiseRt._pending === true || promiseRt._error != null || // (promiseRt._result && Object.keys(promiseRt._result).length === 0) ||
          promiseRt._destory) {
            return loader.apply(void 0, [props].concat(_toConsumableArray(extraArgs)));
          } // loader success


          if (promiseRt && promiseRt._pending === false && promiseRt._error == null) {
            // 标识数据为 destory，保证spa 切换时，loader 重新执行
            promiseRt._destory = true;
            return promiseRt;
          }

          return {};
        }
      }
    };
  };

  plugin.__SPECIALHOOK__ = specialHook;
  plugin.__name__ = '@jupiter-app/plugin-ssr';
  return plugin;
}

export default runtimeSSR;
export { RENDER_LEVEL };
//# sourceMappingURL=ssr.browser.esm.js.map
